import { defaultConfig } from 'app/config/environment';
import { useTranslate } from 'core/hooks/useTranslate';
import { useUser } from 'core/lite/hooks/useUser';
import { Button } from 'ui';
import PreviewContent from 'core/modules/components/general/PreviewContent';
import { detectMultimediaContentBaseOnPath } from 'core/utils/utils';
import md5 from 'md5';
import React, { useEffect, useState } from 'react';

const StudentActivityAttachment = ({ attachedFile, onOpenStudentAttachment }) => {
  const { t } = useTranslate();
  const { isStudent } = useUser();
  const [type, setType] = useState(null);

  useEffect(() => {
    console.log('attachedFile', attachedFile);
    let contentType = detectMultimediaContentBaseOnPath(attachedFile);
    setType(contentType);
    if (!contentType) {
      let contentGuid = md5(attachedFile);
      console.log('contnetGuid', contentGuid);
    }
  }, [attachedFile]);

  return (
    <div>
      {type ? (
        <div>
          <PreviewContent previewImage={true} contentUrl={attachedFile} type={type} canOpenImageDialog={true} />
        </div>
      ) : (
        <Button
          text={t('assigments:See document')}
          leftIcon="external-link"
          onClick={() => onOpenStudentAttachment(`${defaultConfig.BASE_URL_}viewer/externalContent?url=${attachedFile}&hideannotations=${isStudent}`)}
        />
      )}
    </div>
  );
};

StudentActivityAttachment.defaultProps = {
  onOpenStudentAttachment: () => {},
};

export default StudentActivityAttachment;
